import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=94e90f10&scoped=true&"
import script from "./product-info.vue?vue&type=script&lang=js&"
export * from "./product-info.vue?vue&type=script&lang=js&"
import style0 from "./product-info.vue?vue&type=style&index=0&id=94e90f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e90f10",
  null
  
)

export default component.exports